
export const FrenchLocale = 'fr';
